import "./AreasWeCover.module.css";
import Header from "@/reusable_sections/Header";
import Coverage from "./sections/Coverage";
import Expertise from "./sections/Expertise";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function AreasWeCoverPage() {
  return <div>
      <Header />
      <Coverage />
      <Expertise />
      <Quote />
      <Footer />
    </div>;
}